var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(Object.keys(_vm.data).length > 0 ? _vm.data : ''))])
}
var staticRenderFns = []

export { render, staticRenderFns }